import { render, staticRenderFns } from "./DurationDisplay.vue?vue&type=template&id=4071bcb2&scoped=true"
import script from "./DurationDisplay.vue?vue&type=script&lang=js"
export * from "./DurationDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071bcb2",
  null
  
)

export default component.exports